<template>
  <v-sheet
    class="px-3 pt-6 mx-auto"
    color="transparent"
    max-width="1600px"
    width="100%"
  >
    <div class="d-flex align-center justify-space-between">
      <div>
        <TitleWidget>{{ title }}</TitleWidget>

        <div
          v-if="!xsOnly"
          class="secundary--text text-caption text-sm-subtitle-1 font-weight-regular"
        >
          {{ subtitle }}
        </div>
      </div>

      <div
        v-if="add?.link || !!$slots[actions]"
        class="d-flex align-center ml-2 actions"
      >
        <slot name="actions" />

        <v-btn :to="add.link" class="rounded-lg" color="#107823" depressed>
          <v-icon color="white" size="16">mdi-plus</v-icon>

          <div class="white--text text-body-1 text-none ml-1">
            {{ add?.text }}
          </div>
        </v-btn>
      </div>
    </div>

    <slot />
  </v-sheet>
</template>

<script>
import TitleWidget from "@/components/widgets/Title.vue";

export default {
  components: { TitleWidget },
  props: {
    title: String,
    subtitle: String,
    add: {
      type: Object,
      default: () => ({}),
      validator(value) {
        if (!value || Object.keys(value).length === 0) {
          return true;
        }

        return (
          typeof value.link === "string" &&
          value.link.length > 0 &&
          typeof value.text === "string" &&
          value.text.length > 0
        );
      },
    },
  },
  computed: {
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
};
</script>

<style lang="scss" scoped>
.actions {
  gap: 8px;
}
</style>
